import React from 'react';
import { FormState } from '../../types';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { Alert } from '../ui/Alert';
import { Checkbox } from '../ui/Checkbox';
import { propertyTypes, usStates } from '../../data/mockData';
interface Props {
  state: FormState;
  onChange: (field: keyof FormState, value: any) => void;
}
export function PropertyTransaction({
  state,
  onChange
}: Props) {
  const isStreetTBD = state.propertyStreet.toUpperCase() === 'TBD' || !state.propertyStreet;
  const isMadisonECDMissing = !state.madisonECD;
  return <div className="space-y-6" data-id="element-248">
      {isStreetTBD && <Alert variant="error" title="Action Required" data-id="element-249">
          Property street cannot be TBD or empty. Please provide a valid street
          address.
        </Alert>}

      {isMadisonECDMissing && <Alert variant="error" title="Action Required" data-id="element-250">
          Madison ECD (Estimated Closing Date) is missing.
        </Alert>}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-251">
        <Input label="Property Street" value={state.propertyStreet} onChange={e => onChange('propertyStreet', e.target.value)} error={isStreetTBD ? 'Required valid street' : undefined} required data-id="element-252" />
        <Select label="Property State" value={state.propertyState} onChange={e => onChange('propertyState', e.target.value)} options={usStates} required data-id="element-253" />
        <Select label="Property Type" value={state.propertyType} onChange={e => onChange('propertyType', e.target.value)} options={propertyTypes} required data-id="element-254" />
        <Select label="Loan Purpose" value={state.loanPurpose} onChange={e => onChange('loanPurpose', e.target.value)} options={[{
        label: 'Purchase',
        value: 'Purchase'
      }, {
        label: 'Refinance',
        value: 'Refinance'
      }]} required data-id="element-255" />
      </div>

      <div className="pt-4 border-t border-slate-100 dark:border-slate-700" data-id="element-256">
        <div className="max-w-md" data-id="element-257">
          <Input label="Madison ECD (Estimated Closing Date)" type="date" value={state.madisonECD} onChange={e => onChange('madisonECD', e.target.value)} error={isMadisonECDMissing ? 'Required' : undefined} required data-id="element-258" />
          {state.madisonECD && <div className="mt-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-md border border-slate-200 dark:border-slate-700" data-id="element-259">
              <Checkbox label="I certify that this Madison ECD is correct." checked={state.madisonECDCertified} onChange={e => onChange('madisonECDCertified', e.target.checked)} data-id="element-260" />
            </div>}
        </div>
      </div>
    </div>;
}